import React from 'react';
import ReactDOM from 'react-dom';
import throttle from 'lodash/throttle';
import Listing from 'components/common/Listing';
import Spinner from 'components/common/Spinner';


class ListingList extends React.Component {
  constructor(props) {
    super(props);

    this.onScroll = throttle(this.onScroll, 100).bind(this);
  }

  componentDidMount() {
    this.el = ReactDOM.findDOMNode(this);
    if (window.innerWidth < 768) {
      this.target = window;
      this.isWindow = true;
      this.innerHeight = window.innerHeight;
    } else {
      this.target = this.el;
      this.offsetHeight = this.el.offsetHeight;
    }

    this.target.addEventListener("scroll", this.onScroll);
  }

  componentWillUnmount() {
    this.target.removeEventListener("scroll", this.onScroll);
  }

  onScroll(e) {
    if (this.isWindow) {
      if (this.el.getBoundingClientRect().bottom - this.innerHeight < 40) {
        this.props.onReachBottom();
      }
    } else {
      const { scrollHeight, scrollTop } = e.target;
      if (scrollHeight - scrollTop - this.offsetHeight < 40) {
        this.props.onReachBottom();
      }
    }
  }

  render() {
    const { listings, onEnterListing, query, isFetching } = this.props;
    const list = Object.keys(listings).map(listingId => {
      const listing = listings[listingId];
      return (
        <div className="col-lg-6 col-12 pr-xl-5 pr-lg-4 pr-5 pb-xl-5 pb-lg-4 pb-5 pl-0" key={listingId}
             onMouseEnter={e => onEnterListing(listing)}>
          <Listing {...listing } query={query}/>
        </div>
      );
    });

    return (
      <div className="d-flex flex-wrap pt-xl-5 pt-lg-4 pt-5 pl-xl-5 pl-lg-4 pl-5 listings-list">
        {list}
        { isFetching && <div className="col-12 text-center">
          <Spinner/>
        </div> }
      </div>
    );
  }
}

export default ListingList;


// WEBPACK FOOTER //
// ./src/components/ListingList.js